import { Controller } from '@hotwired/stimulus';

export default class AdIdController extends Controller {
  static targets = ['input'];

  disconnect() {
    this.inputTarget.value = '';
  }

  filterInput() {
    this.inputTarget.value = this.inputTarget.value.replace(/\D/g, '').replace(/^0+/, '');
  }

  navigate() {
    const value = this.inputTarget.value.trim();
    if (!value) {
      return;
    }
    window.open(`/${value}`, '_blank');
  }
}
